"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _UnionSync = _interopRequireDefault(require("./components/UnionSync.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UnionSyncPage',
  components: {
    UnionSync: _UnionSync.default
  },
  methods: {
    refreshPage: function refreshPage() {
      this.$message.info('正在刷新页面...');
      location.reload();
    },
    handleSyncCompleted: function handleSyncCompleted(syncType) {
      console.log('同步完成:', syncType);
      // 可以在这里添加同步完成后的处理逻辑
      // 比如刷新其他页面的数据等
    }
  }
};